module.exports = __webpack_public_path__ + "static/media/clinic.13eb9d45.JPG";